import NewsEditor from './NewsEditor';
export default NewsEditor;
